import { Component } from '@angular/core';
import { Store } from "@ngrx/store";
import { firstValueFrom, map, Observable } from "rxjs";
import { ModalController, IonIcon } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonCheckbox } from "@ionic/angular/standalone";
import { NotificationChannel, NotificationPreference, ValidationUtil } from "@qid/core";
import { User, UsersSelectors } from '../../modules/user';
import { AuthSelectors } from "../../modules/authentication";
import { OrganisationUserDataRepository, OrganisationUserSelectors } from "../../modules/organisation-user";
import { RestService } from "../../services/rest.service";
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, SuperBackButtonComponent } from '@qid/super';

@Component({
  selector: 'app-setting',
  templateUrl: './notifications-setting-page.component.html',
  styleUrls: ['./notifications-setting-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonCheckbox,
    SuperBackButtonComponent
  ],
})
export class NotificationsSettingPage {

  protected readonly NotificationChannel = NotificationChannel;
  public user$: Observable<User> = this.store.select(UsersSelectors.selectAuthenticatedUser)
  public activeAccount$ = this.store.select(AuthSelectors.selectActiveAccount);
  public userRole$ = this.store.select(OrganisationUserSelectors.selectActiveOrganisationUserRole);
  public defaultNotificationPrefs: NotificationPreference[] = null

  constructor(
    private store: Store,
    public modalController: ModalController,
    private organisationUserDataRepository: OrganisationUserDataRepository,
    private restService: RestService
  ) {
  }

  ngOnInit() {

  }

  ionViewDidEnter() {
    this.fetchDefaultNotificationPreferences()
  }

  async fetchDefaultNotificationPreferences() {
    const res = await this.restService.send<NotificationPreference[]>({
      url: 'default-notification-preferences',
      method: "GET"
    })
    if (res && res.data) {
      this.defaultNotificationPrefs = res.data
    }
  }

  public activeOrgUserNotificationPrefs$ = this.store.select(OrganisationUserSelectors.selectActiveOrganisationUserNotificationPreferences)
    .pipe(
      map((orgUserPrefs) => {

        if (!orgUserPrefs) {
          return this.defaultNotificationPrefs;
        }

        let finalPrefs: NotificationPreference[] = [];

        for (let pref of this.defaultNotificationPrefs) {
          const userPref = orgUserPrefs.find(orgUserPref => orgUserPref.event == pref.event);
          if (userPref) {
            pref.channelsEnabled = userPref.channelsEnabled
          }
          finalPrefs.push(pref);
        }
        return finalPrefs

      })
    )

  close() {
    this.modalController.dismiss()
  }

  async onToggle(event: any, pref: NotificationPreference, channel: NotificationChannel) {

    pref = JSON.parse(JSON.stringify(pref))

    if (!event?.detail) {
      return
    }

    if (!pref.channelsEnabled) {
      pref.channelsEnabled = []
    }

    if (ValidationUtil.isTrue(event.detail.checked) && pref.channelsEnabled.indexOf(channel) == -1) {
      pref.channelsEnabled.push(channel)
    }

    if (ValidationUtil.isFalse(event.detail.checked) && pref.channelsEnabled.indexOf(channel) != -1) {
      pref.channelsEnabled.splice(pref.channelsEnabled.indexOf(channel), 1)
    }

    let currentPrefs = await firstValueFrom(this.store.select(OrganisationUserSelectors.selectActiveOrganisationUserNotificationPreferences))

    if (currentPrefs) {
      currentPrefs = JSON.parse(JSON.stringify(currentPrefs))
    }

    if (currentPrefs && currentPrefs.find(currentPref => currentPref.event == pref.event)) {

      const index = currentPrefs.findIndex(currentPref => currentPref.event == pref.event)
      currentPrefs[index] = pref;

    } else {
      currentPrefs = [{ ...pref }];
    }

    this.updateNotificationPreference(currentPrefs);

  }

  async updateNotificationPreference(notificationPreference: NotificationPreference[]) {
    const orgUser = await firstValueFrom(this.store.select(OrganisationUserSelectors.selectActiveOrganisationUser))
    return this.organisationUserDataRepository.updateNotificationPreferences(orgUser._id, notificationPreference)
  }

}
